import React from 'react';
import "./UgrightSection.css";
import SocialComponent from '../../../SocialComponent/SocialComponent';
import ImageComponent from '../../../ImageComponent/ImageComponent';

function UgrightSection() {
    return (
        <>
            {/* Ug Right Section Start */}
                    <SocialComponent/>
                    <ImageComponent/>
            {/* Ug Right Section End */}
        </>
    )
}

export default UgrightSection;